export const DOMAIN_CONFIG: Record<string, any> = {
  'localhost': {
    tenantId: 'IQIGAI',          // Custom property to define the tenant
    ssoLoginEnabled: true,
    isStaffingDomain: true,
    proctoringServerEnabled: true,   // GPU proctoring machine start/stop, kept on for local testing
    proctoringAllowedEmails: ['saswat@f360.com'],
  },
  'f360qa.foyr.com': {
    tenantId: 'IQIGAI',          // Custom property to define the tenant
    ssoLoginEnabled: false,
    isStaffingDomain: false, 
    proctoringServerEnabled: false,
  },
  'fractal360.in': {
    tenantId: 'IQIGAI',          // Custom property to define the tenant
    ssoLoginEnabled: false,
    isStaffingDomain: false, 
    proctoringServerEnabled: false,
  },
  'f360.foyr.com': {
    tenantId: 'IQIGAI',          // Custom property to define the tenant
    ssoLoginEnabled: false,
    isStaffingDomain: false, 
    proctoringServerEnabled: false,
  },
  'fractal.iqigai.ai': {
    tenantId: 'FRACTAL',          // Custom property to define the tenant
    ssoLoginEnabled: true,
    isStaffingDomain: true,         
    proctoringServerEnabled: false,
  },

  //These are added for managing proctoring machine feature access.
  'qa.iqigai.ai': {
    proctoringServerEnabled: true,
    proctoringAllowedEmails: ['saswat@f360.com'],
  },
  'app.iqigai.ai': {
    proctoringServerEnabled: true,
    proctoringAllowedEmails: ['admin@fractal.com'],
  },
  'fractalqa.iqigai.ai': {
    tenantId: 'FRACTAL',          // Custom property to define the tenant
    ssoLoginEnabled: true,
    isStaffingDomain: true,         
  },
  'fractalpreprod.iqigai.ai': {
    tenantId: 'FRACTAL',          // Custom property to define the tenant
    ssoLoginEnabled: true,
    isStaffingDomain: true,         
  }
};